import preact, {Component, h} from "preact";
import {AppPage} from "../_common/components/app-page";
import {connect} from "react-redux";
import {ModalLink} from "../_common/components/modal";
import {rndStr} from "../_common/common";
import {t} from '../_i18n';
import {Link, useParams} from "react-router-dom";
import {CF, FR, E} from "../_common/layout";
import {Helmet} from "react-helmet";

import {
    fetchAcademicPrograms,
    fetchOffers,
    fetchStates,
    clearOffers,
    fetchCompanyOffersCount,
    fetchCompanyOffersFilter
} from "../_rx/jobs/actions";
import {AcademicProgram, CompanyOfferItem, State} from "../_api";
import Tabs from './components/Tabs'
import OfferCard from './components/OfferCard'
import ModalFilter from "./components/modalFilter";
import Pagination from "../_common/components/pagination/index";
import {OFFERS_LIMIT_PAGES, OFFERS_LIST_TITLE, OFFERS_LIST_TITLE_PAGE} from '../constants'
import AlertBox from "../_common/components/AlertBox/AlertBox";

type Props = {
    offers: any,
    fixtures: {academic_programs: AcademicProgram[], states: State[]},
    fetchOffers:typeof fetchOffers,
    fetchStates: typeof fetchStates,
    clearOffers: typeof clearOffers,
    fetchAcademicPrograms: typeof fetchAcademicPrograms,
    fetchCompanyOffersCount: typeof fetchCompanyOffersCount,
    companyOffersFilter: any,
    fetchCompanyOffersFilter: typeof fetchCompanyOffersFilter,
    companyOffersCount: any,
    status : string,
    company: any,
    match: any,
    prevMatch: any,
    history: any,
}

type StateComp = {
    idModal: string,
    showModal: any,
    filter: any,
    loadingNewOffers: boolean
}

const status_type: any = {
    drafts: 0,
    active: 1,
    archived: 2,
}

class View extends Component<Props, StateComp> {

    constructor(props: Props) {
        super(props);
        this.state = {
            idModal: rndStr(),
            showModal: false,
            filter: null,
            loadingNewOffers: false
        }

    }

    async componentDidMount() {
        await this.initializeComponent()
    }

    // si no no se actualiza el listado al cambiar de pestaña. Esto pasa solo al poner el Switch en el routing
    async componentDidUpdate(previousProps: Readonly<Props>, previousState: Readonly<StateComp>, snapshot: any) {
        const page = this.props.match.params.page
        const prevPage = previousProps.match.params.page

        if(this.props.status != previousProps.status) {
            this.props.clearOffers()
            this.initializeComponent();
        } else if(page !== prevPage  || this.state.filter !== previousState.filter){
            await this.props.fetchOffers({
                status: status_type[this.props.status],
                limit: OFFERS_LIMIT_PAGES,
                page,
                ...this.state.filter
            });
            this.setState({loadingNewOffers: false})

        }

    }

    async initializeComponent() {
        const { fetchOffers, fetchCompanyOffersCount, status, fixtures, fetchAcademicPrograms, fetchStates, fetchCompanyOffersFilter, match} = this.props;
        fetchOffers({status: status_type[status], limit: OFFERS_LIMIT_PAGES, page: (match.params.page ? match.params.page : 1), ...this.state.filter});
        fetchCompanyOffersCount({status: status_type[status], limit: OFFERS_LIMIT_PAGES, page: (match.params.page ? match.params.page : 1), ...this.state.filter});
        fetchCompanyOffersFilter({status: status_type[status]});

        if(!fixtures.academic_programs) // lazy
            fetchAcademicPrograms();

        if(!fixtures.states) // lazy
            fetchStates();
    }

    renderOffersNum = (offersNum: number) => {
        let text: string = '';
        if (offersNum === 0){
            text = t('No tienes ninguna oferta.')
        } else if (offersNum === 1){
            text = offersNum + " " + t("oferta")
        } else if (offersNum > 1){
            text = offersNum + " " + t("ofertas")
        }
        return text;
    }

    handlePageChanged = (newPage: number) => {
        const {match, history} = this.props
        const actualPage = parseInt(match.params.page)
        const isSamePage = (actualPage === newPage) || (isNaN(actualPage) && newPage === 1)
        if (isSamePage) return null

        history.push('/'+match.url.split('/')[1] +'/'+ newPage)
        this.setState({loadingNewOffers: true})

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    handleFilter = (filter: any) => {
        this.props.history.push('/'+this.props.match.url.split('/')[1])
        this.setState({showModal: false, filter:filter})
    }

    handleCloseFilter = () => this.setState({filter: null})


    render({offers, fixtures:{academic_programs,states}, companyOffersFilter, companyOffersCount, status, company, match, history}: Props) {

        if(!academic_programs || !states || !companyOffersFilter || !companyOffersCount) return null;

        return <CF className="max-width-980">
            <Helmet>
                <title>{OFFERS_LIST_TITLE_PAGE}</title>
            </Helmet>
            <FR className='sm-flex-center-y flex-column sm-no-reverse'>
                <span className='sm-col-65'><h1 className='font-medium'>{t(OFFERS_LIST_TITLE)}</h1></span>
                <span className='sm-col-35 '>
                    <Link to={'/new'} className='no-decoration'><div className="btn btn-ghost info">
                        <span className={'text-info text-normal t-upper'}>
                            {t('Publicar Oferta')}
                        </span></div>
                    </Link>
                </span>
            </FR>
            {
                company && (!company.subtitle || (!company.empleados && company.empleados !== 0) || !company.text || !company.location) &&
                <AlertBox type='warning' className='m-top'>
                    <span>¡Hola! Primero de todo, <Link to={'/company/edit'} className='t-underline'>completa el perfil de tu empresa.</Link></span>
                </AlertBox>
            }

            <Tabs status={status}/>
            <FR className='m-bottom row-2-el'>
                    <E>
                        <span className="offer">
                            { offers?.pagination && this.renderOffersNum(offers.pagination.totalResults)}
                        </span>
                    </E>

                    <E className='t-right'>
                        {companyOffersFilter.showGeneral && <div className='cursor-pointer'>
                            <ModalLink id={this.state.idModal}><span className='t-upper'
                                                                     onClick={() => this.setState({showModal: true})}>Filtrar</span></ModalLink>
                            {(this.state.filter !== null && Object.keys(this.state.filter).length !== 0) && <span
                                className="m-l-half sm-m-l-half">{"(" + Object.values(this.state.filter).join(",").split(",").length + ")"}</span>}
                            <i className="fal fa-sliders-h p-left" aria-hidden="true"/>
                            <ModalFilter id={this.state.idModal}
                                         states={states}
                                         academicPrograms={academic_programs}
                                         companyOffersFilter={companyOffersFilter}
                                         companyOffersCount={companyOffersCount}
                                         status={status_type[this.props.status]}
                                         history={history}
                                         handleFilter={this.handleFilter}
                                         handleCloseFilter={this.handleCloseFilter}
                                         showModal={this.state.showModal}
                            />
                        </div>}
                    </E>
            </FR>
            <FR className='row-1-el'>
                {offers?.data?.map((offer: any) => (
                    <E>
                        <OfferCard
                            states={states}
                            filter={this.state.filter}
                            key={offer.id}
                            id={offer.id}
                            offer={offer}
                            academicPrograms={academic_programs}
                            status={this.props.status}
                            statusType={status_type[this.props.status]}
                            page={match.params.page}
                            history={history}
                            loading={this.state.loadingNewOffers}
                        />
                    </E>))}
            </FR>
            {
                offers?.pagination && <div className='m-top'>
                    <Pagination pageMax={offers.pagination.totalPages} page={parseInt((match.params.page === undefined) ? 1 : match.params.page)} onClick={(page: number) => this.handlePageChanged(page)}/>
                </div>
            }


        </CF>;
    }
};


const ConnectedView: any = connect(
    ({offers, fixtures, companyOffersFilter, company, companyOffersCount }:any)=>({offers, fixtures, companyOffersFilter, company, companyOffersCount}), {fetchOffers, fetchCompanyOffersCount, fetchCompanyOffersFilter, fetchAcademicPrograms, fetchStates, clearOffers})(View as any);

export default ({status='active', ...props}) => {
    return <AppPage
        name="offers"
        className="max-width-780">
        <ConnectedView status={status} match={props.match} history={props.history}/>

    </AppPage>
}
;
